import React from "react"
import {FieldArray, withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";
import {handleApiResponse, types as actions} from "../../../../crud-actions";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Progress} from "reactstrap";
import {Link} from "react-router-dom";
import SuccessModal from "../../success-modal";
import AttachmentsList from "../../attachments-list";
import ContentUnitHeader from "../../content-unit-header";
import BaseComponent from "../../../base-component";
import Page1 from './page-1';
import Page2 from './page-2';
import Page3 from './page-3';
import Page4 from './page-4';
import Page5 from './page-5';
import Page6 from './page-6';
import Complete from './complete';

class PersonalForm extends BaseComponent {

    constructor(params) {
        super(params);

        const { assignment } = this.props;
        const { employee_data } = assignment;

        this.state = {
            successModal: false,
            page: employee_data && employee_data['data'] && employee_data['data']['page'] || 1
        }
    }

    previousPage = () => {
        this.setState({ page: Math.max(1, this.state.page - 1)});
    };

    nextPage = () => {
        this.setState({ page: Math.min(7, this.state.page + 1)});
    };

    setPage = (page) => {
        this.setState({ page: page });
    };

    sendForm = (values, form) => {
        let promise = this.props.assignmentAction('api/v1', this.props.assignment.id, { execute: 'submit_form', data: values.data });
        handleApiResponse('ASSIGNMENT', 'ACTION', promise,
            (result) => {
                this.props.selectAssignment('api/v1', this.props.assignment.id);
                this.props.clearNotifications();
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.personal_forms.message.submit.fail'}));
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'data');
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }).then(() => {
                form.setSubmitting(false);
            });
    };

    render() {
        const initPersonalForm = {
            data: {
                page: 1,

                // Page 1

                salutation: '',
                title_before_name: '',
                title_after_name: '',
                name: '',
                surname: '',
                former_surname: '',

                // Page 2

                address_street: '',
                address_land_registry_number: '',
                address_house_number: '',
                address_city: '',
                address_country: '',
                address_postcode: '',
                contact_address_different: false,
                contact_address_street: '',
                contact_address_land_registry_number: '',
                contact_address_house_number: '',
                contact_address_city: '',
                contact_address_country: '',
                contact_address_postcode: '',
                phone_country: '',
                phone: '',

                // Page 3

                date_of_birth_day: '',
                date_of_birth_month: '',
                date_of_birth_year: '',
                country_of_birth: '',
                place_of_birth: '',
                personal_identification_number: '',
                personal_identification_number_check: '',
                citizenship: '',
                student: '',
                retiree: '',
                retirement_type: '',
                drivers_license: '',
                drivers_license_group: '',
                disability: '',
                invalidity: '',
                invalidity_level_1: '',
                invalidity_level_2: '',
                invalidity_level_3: '',

                // Page 4

                health_insurance_info: false,
                health_insurance_company: '',
                first_cr_employment: '',
                foreigner_insurance_number: '',
                foreigner_identification_number: '',
                bank_co: '',
                bank_account_none: false,
                bank_account_prefix: '',
                bank_account_number: '',
                education_school: '',
                education_school_start: '',
                education_school_end: '',
                income_deductions: '',
                income_deductions_info: false,
                residence_permit_no: '',
                residence_permit_expiration_date: '',
                foregin_pension: '',
                foreign_pension_timespan: '',
                foreign_pension_name: '',
                foreign_pension_beneficiary_name: '',
                foreign_pension_beneficiary_address_street: '',
                foreign_pension_beneficiary_address_city: '',
                foreign_pension_beneficiary_address_postcode: '',
                foreign_pension_beneficiary_address_country: '',
                foreign_pension_beneficiary_identifier: '',

                // Page 5

                correctness: false,
                exclusivity: false
            }
        };

        const { assignment, constants } = this.props;

        const contentUnit = assignment.content_unit;
        const employeeData = assignment.employee_data || initPersonalForm;
        const isComplete = assignment.state === 'complete';

        const formPage = employeeData.data.page;

        const formProps = {
            contentUnit: contentUnit,
            assignment: assignment,
            resource: employeeData,
            isComplete: isComplete,
            submit: this.sendForm,
            previous: this.previousPage,
            next: this.nextPage,
            setPage: this.setPage,
            constants: constants
        };

        const { page } = this.state;
        const pageMax = 6;
        const virtualPage = Math.min(pageMax, page);

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit} hideEstimatedTime={isComplete} />
                {
                    page < 7 &&
                    <div className='container'>
                        Stránka {virtualPage} / 6<br/>
                        <Progress value={virtualPage} max={pageMax} className='mb-2 mt-2'/>
                        <hr/>
                    </div>
                }
                <div className='container'>
                    { page === 1 && <Page1 {...formProps}/> }
                    { page === 2 && <Page2 {...formProps}/> }
                    { page === 3 && <Page3 {...formProps}/> }
                    { page === 4 && <Page4 {...formProps}/> }
                    { page === 5 && <Page5 {...formProps}/> }
                    { page === 6 && <Page6 {...formProps}/> }
                    { page === 7 && <Complete {...formProps}/> }
                    <AttachmentsList contentUnit={contentUnit}/>
                </div>
                <SuccessModal isOpen={this.state.successModal}>
                    <ModalHeader>{contentUnit.title}</ModalHeader>
                    <ModalBody>
                        <FormattedMessage id='app.personal_forms.message.submit.success'/>
                    </ModalBody>
                    <ModalFooter>
                        <Link to='/dashboard' className={'btn btn-green'}><FormattedMessage id='app.actions.ok'/></Link>
                    </ModalFooter>
                </SuccessModal>
            </div>
        )
    };
}

export default injectIntl(PersonalForm);
